import React, {
  ReactElement, ReactNode, useState,
} from 'react';
import {
  Button, Col, FormGroup, Label, Row, Textarea,
} from 'idsk-react-components';
import Definicia from '../../../../../model/Definicia';
import './doktrinalnaDefiniciaItem.scss';
import { SafeParameterSetter } from '../../../../../model/SafeParameterSetter';

interface Props {
  setItemList: (data: Definicia[]) => void;
  itemId: number;
  children: ReactNode;
  itemList: Array<Definicia>;
  getFieldErrorMessage: (fieldName: string) => string;
  clearFieldErrorMessage: (fieldName: string) => void;
  clearAllFieldErrorMessages: () => void;
}

const DoktrinalnaDefiniciaItem = ({
  setItemList,
  itemId,
  children,
  itemList = [],
  clearFieldErrorMessage,
  clearAllFieldErrorMessages,
  getFieldErrorMessage,
}: Props): ReactElement => {
  const [definicia, setDefinicia] = useState<Definicia>(itemList[itemId]);
  const onRemove = (): void => {
    setItemList(itemList.filter((_, index) => index !== itemId));
    if (clearAllFieldErrorMessages) {
      clearAllFieldErrorMessages();
    }
  };

  const updateField: SafeParameterSetter<Definicia> = (fieldName, value) => {
    setDefinicia(prevState => ({ ...prevState, [fieldName]: value }));

    const newFormValues = [...itemList];
    newFormValues[itemId] = { ...definicia, [fieldName]: value };
    setItemList(newFormValues);

    if (clearFieldErrorMessage) {
      clearFieldErrorMessage(fieldName + itemId);
    }
  };

  return (
    <>
      <div className="doktrinalna-definicia-item">
        <FormGroup>
          <Row>
            <Col width="two-thirds">
              <Label htmlFor="definicia">Doktrinálna definícia</Label>
            </Col>
          </Row>
          <Row>
            <Col width="two-thirds">
              <Textarea
                name="definicia"
                value={definicia.definicia}
                onChange={({ target }) => updateField('definicia', target.value)}
                error={getFieldErrorMessage(`definicia${itemId}`)}
                maxLength={4096}
                rows={3}
                expandHeight
                showRemaining
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col width="two-thirds">
              <Label htmlFor="zdroj">
                Doktrinálny zdroj <span className="not-required"> (nepovinný údaj)</span>
              </Label>
            </Col>
          </Row>
          <Row>
            <Col width="two-thirds">
              <Textarea
                name="zdroj"
                type="text"
                maxLength={256}
                rows={1}
                expandHeight
                value={definicia.zdroj}
                onChange={({ target }) => updateField('zdroj', target.value)}
                error={getFieldErrorMessage(`zdroj${itemId}`)}
              />
            </Col>
          </Row>
        </FormGroup>

        {itemList.length > 0 && (
        <Row>
          <Col width="two-thirds">
            <Button
              type="button"
              size="large"
              className="remove-button"
              buttonStyle="negative"
              onClick={onRemove}
            >
              Zmazať definíciu
            </Button>
          </Col>
        </Row>
        )}
      </div>
      {children && definicia.definicia && definicia.definicia.trim().length > 0 && <>{children}</>}
    </>
  );
};

export default DoktrinalnaDefiniciaItem;
